import { useCallback } from "react"

import { SelfIntersectionObserver } from "@/components/IntersectionObserver/IntersectionObserver.tsx"
import { batchInfo } from "@/lib/apiClient/client.ts"

import type { BatchInfo } from "@/lib/client/generated/TypeDefinitions.ts"
import type { Dispatch, SetStateAction } from "react"


export const BatchLoader = ({ setBatch, hasMore, nextOffset }: {
  setBatch: Dispatch<SetStateAction<BatchInfo>>
  batchSize: number
  hasMore: boolean
  nextOffset: string | null
}) => {
  const onBecomeVisible = useCallback(() => {
    setBatch(prev => batchInfo(prev.batchSize, nextOffset))
  }, [setBatch, nextOffset])

  return (
    hasMore && <SelfIntersectionObserver onBecomeVisible={onBecomeVisible} />
  )
}
